import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import { Category } from '@noths/polaris-client-ribbons-design-system';

import { PlacementContext } from 'src/types/PlacementContext';

export interface CategoryClickTrackingContext extends PlacementContext {
  categoryIndex: number;
  category: Category;
  numberOfItems: number;
}

export interface CategoryImpressionTrackingContext extends PlacementContext {
  numberOfItems: number;
}

export const trackImpression = ({
  trackingPosition,
  trackingTitle,
  numberOfItems,
  placementContentType,
}: CategoryImpressionTrackingContext) => {
  sendGAEvent({
    event: 'custom_event',
    event_action: 'Impression',
    event_category: `${trackingPosition} | ${placementContentType}`,
    event_label: `${trackingPosition} | ${trackingTitle} | ${numberOfItems}`.toLowerCase(),
    event_name: 'view_content',
    content_position: `${trackingPosition}`,
    content_type: `${placementContentType}|${trackingTitle}`.toLowerCase(),
    total_options: `${numberOfItems}`,
  });
};

export const trackCategoryClick = (
  e: React.MouseEvent<HTMLAnchorElement>,
  categoryTracking: CategoryClickTrackingContext,
) => {
  const {
    category: { categoryName, categoryHref },
    categoryIndex,
    numberOfItems,
    trackingPosition,
    trackingTitle,
    placementContentType,
  } = categoryTracking;

  sendGALinkClickEvent(e, {
    event: 'custom_event',
    event_action: 'Category click',
    event_category: `${trackingPosition} | ${placementContentType}`,
    event_label: `${trackingPosition} | ${trackingTitle} | ${
      categoryIndex + 1
    } | ${categoryName}`.toLowerCase(),
    event_name: 'select_content',
    event_details: 'category click',
    content_position: `${trackingPosition}`,
    content_type: `${placementContentType}|${trackingTitle}`.toLowerCase(),
    total_options: `${numberOfItems}`,
    selected_position: `${categoryIndex + 1}`,
    item_id: `${categoryName}`.toLowerCase(),
    destination_URL: `${window.location.origin}${categoryHref}`,
  });
};
